import { graphql } from 'gatsby';
import BlogPostsPagination from '../templates/blog-posts-pagination';

export default BlogPostsPagination;

export const blogPostsByCategoryQuery = graphql`
  query blogPostsByCategoryQuery($category: String!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { categories: { in: [$category] } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD.MM.YYYY")
            title
            categories
          }
        }
      }
    }
  }
`;
